import { List } from 'react-admin'
import ResourceListHeader from '../components/ResourceListHeader'
import EmrDatagrid from './EmrDatagrid'

const EmrList = () => (
  <>
    <ResourceListHeader resource="emrs" hintKey="pos.menu.notes_hint" />
    {/* Clinical timeline: default to newest-first by the shown "date"
        (timestamp) column. Without this, react-admin defaults to id ASC. */}
    <List sort={{ field: 'timestamp', order: 'DESC' }}>
      <EmrDatagrid rowClick="edit" />
    </List>
  </>
)

export default EmrList
